// extracted by css-extract-rspack-plugin
module.exports =  {"other_calc_container":"V8tQS","other_calc_wrap":"sPWJn","card_container":"kT3bT","calculator_card":"jMDhi"};